import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { useGetAccessiblePagesQuery } from '../services/dashboardApi';

const ProtectedRoute = ({
  children,
  requiredPermissions = [],
  requireAll = false
}) => {
  const location = useLocation();
  const { isAuthenticated, user, hasPermission, loading: authLoading } = useAuth(requiredPermissions);

  // Use the API to check if this specific page is accessible to the user
  const { data: pageData, isLoading: pageLoading } = useGetAccessiblePagesQuery(undefined, {
    skip: !isAuthenticated
  });

  // Calculate if the page should be blocked based on accessible pages from backend
  const isPagePathAllowed = useMemo(() => {
    if (!pageData?.pages) return true; // Default to true while loading or if data is missing

    const path = location.pathname;
    const pages = pageData.pages;

    // Check for exact match
    if (pages[path] !== undefined) return pages[path];

    // Check for parameterized routes (e.g., /org-management/org-structure/123)
    const matchingKey = Object.keys(pages).find(key => {
      if (!key.includes(':')) return false;
      const regex = new RegExp('^' + key.replace(/:[^\s/]+/g, '[^/]+') + '$');
      return regex.test(path);
    });

    if (matchingKey) return pages[matchingKey];

    return true;
  }, [pageData, location.pathname]);

  const loading = authLoading || pageLoading;

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" state={{ forced: true, from: location }} replace />;
  }

  // if (requiredPermissions.length > 0 && !hasPermission) {
  //   return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  // }

  // if (!isPagePathAllowed) {
  //   return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  // }

  return children;
};

export default ProtectedRoute;
